import { collection, doc, getDoc, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebase';

const adminRecordCache = new Map();

export const normalizeAdminType = (value) => {
  const normalized = String(value || 'admin').trim().toLowerCase();
  if (normalized === 'superadmin') return 'superAdmin';
  if (normalized === 'viewer') return 'viewer';
  return 'admin';
};

export const resolveAdminRecord = async (user) => {
  if (!user) {
    return null;
  }

  const cacheKey = user.uid || user.email;
  if (cacheKey && adminRecordCache.has(cacheKey)) {
    return adminRecordCache.get(cacheKey);
  }

  const loadRecord = async () => {
    const directDoc = await getDoc(doc(db, 'Admins', user.uid));
    if (directDoc.exists()) {
      return { id: directDoc.id, ...directDoc.data() };
    }

    const byUserId = await getDocs(query(collection(db, 'Admins'), where('userID', '==', user.uid)));
    if (!byUserId.empty) {
      const foundDoc = byUserId.docs[0];
      return { id: foundDoc.id, ...foundDoc.data() };
    }

    if (user.email) {
      const byEmail = await getDocs(query(collection(db, 'Admins'), where('userEmail', '==', user.email)));
      if (!byEmail.empty) {
        const foundDoc = byEmail.docs[0];
        return { id: foundDoc.id, ...foundDoc.data() };
      }
    }

    return null;
  };

  const recordPromise = loadRecord().catch((error) => {
    if (cacheKey) {
      adminRecordCache.delete(cacheKey);
    }
    throw error;
  });

  if (cacheKey) {
    adminRecordCache.set(cacheKey, recordPromise);
  }

  return recordPromise;
};

export const canAccessAdminType = (adminType, allowedAdminTypes = ['admin', 'superAdmin']) =>
  allowedAdminTypes.includes(normalizeAdminType(adminType));
